import { USER_QUERY_KEY } from "@frontend-shared/constants";
import type { IUserProfile } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { userApi } from "@/api/services";

export const useCompleteTour = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => userApi.completeTour(),
    onMutate: () => {
      queryClient.setQueryData<IUserProfile>([USER_QUERY_KEY], (old) => {
        if (!old) {
          return old;
        }

        return {
          ...old,
          isTourCompleted: true,
        };
      });
    },
    onError: (error) => {
      console.error("Failed to update tour completion status:", error);
    },
  });
};
